import axiosInstance from "../backend/axiosInstance";

export const Maps = {};

let fetched = false;

export async function fetchMaps() {
    if (fetched) return;
    fetched = true;

    try {
        const response = await axiosInstance.get("/maps/");

        response.data.forEach((item) => {
            Maps[item.mapName] = {
                splash: item.link,
                minimap: item.linkMiniMap,
            };
        });
    } catch (error) {
        console.error("Error fetching maps:", error);
    }
}

export const MapsData = {
    Ascent: {
        xMultiplier: 0.00007,
        yMultiplier: -0.00007,
        xScalarToAdd: 0.813895,
        yScalarToAdd: 0.573242
    },
    Abyss: {
        xMultiplier: 0.000081,
        yMultiplier: -0.000081,
        xScalarToAdd: 0.5,
        yScalarToAdd: 0.5,
    },
    Bind: {
        xMultiplier: 0.000059,
        yMultiplier: -0.000059,
        xScalarToAdd: 0.576941,
        yScalarToAdd: 0.967566,
    },
    Breeze: {
        xMultiplier: 0.00007,
        yMultiplier: -0.00007,
        xScalarToAdd: 0.465123,
        yScalarToAdd: 0.833078,
    },
    Corrode: {
        xMultiplier: 0.00007,
        yMultiplier: -0.00007,
        xScalarToAdd: 0.526158,
        yScalarToAdd: 0.5,
    },
    Fracture: {
        xMultiplier: 0.000078,
        yMultiplier: -0.000078,
        xScalarToAdd: 0.556952,
        yScalarToAdd: 1.155886,
    },
    Haven: {
        xMultiplier: 0.000075,
        yMultiplier: -0.000075,
        xScalarToAdd: 1.09345,
        yScalarToAdd: 0.642728,
    },
    Icebox: {
        xMultiplier: 0.000072,
        yMultiplier: -0.000072,
        xScalarToAdd: 0.460214,
        yScalarToAdd: 0.304687,
    },
    Lotus: {
        xMultiplier: 0.000072,
        yMultiplier: -0.000072,
        xScalarToAdd: 0.454789,
        yScalarToAdd: 0.917752,
    },
    Pearl: {
        xMultiplier: 0.000078,
        yMultiplier: -0.000078,
        xScalarToAdd: 0.480469,
        yScalarToAdd: 0.916016,
    },
    Split: {
        xMultiplier: 0.000078,
        yMultiplier: -0.000078,
        xScalarToAdd: 0.842188,
        yScalarToAdd: 0.697578,
    },
    Sunset: {
        xMultiplier: 0.000078,
        yMultiplier: -0.000078,
        xScalarToAdd: 0.5,
        yScalarToAdd: 0.515625,
    }
};
